export default "__VITE_ASSET__qfajCSId__"